import { notifications } from '@mantine/notifications'

const defaults = {
	withCloseButton: true,
}

const show = (options = {}) => notifications.show({ ...defaults, ...options })

export const toast = {
	show,
	success: (options = {}) => show({ color: 'teal', ...options }),
	error: (options = {}) => show({ color: 'red', ...options }),
	info: (options = {}) => show({ color: 'blue', ...options }),
	hide: (id) => notifications.hide(id),
}
